import { render, staticRenderFns } from "./PageNode.vue?vue&type=template&id=080de37c&scoped=true"
import script from "./PageNode.vue?vue&type=script&lang=js"
export * from "./PageNode.vue?vue&type=script&lang=js"
import style0 from "./PageNode.vue?vue&type=style&index=0&id=080de37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080de37c",
  null
  
)

export default component.exports